//REGISTER
export const mobileRegex = /^[8-9]{1}[\d]{7}/i;
export const iuRegex =/^[\d]{10}/i;
export const vehicleRegex =/^[[A-Za-z]{1,3}[\d]{1,4}[A-Za-z0-9]{1,2}$/i;
export const numRegex=/^[0-9]+$/i;
export const emailRegex=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
export const passwordRegex=/^.*((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;




















































